import React from 'react'
import PropTypes from 'prop-types'

const Row = ({ children }) => {
  return (
    <tr>
      {children}
    </tr>
  )
}

Row.propTypes = { children: PropTypes.any }
Row.displayName = 'TableRow'

export default Row
